import { createFileRoute } from "@tanstack/react-router";
import BlueSkyFees from "@/components/BlueSkyFees";

function RouteComponent() {
  return <BlueSkyFees />;
}

export const Route = createFileRoute("/_authenticated/blue-sky-fees/")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
